import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { SiteConfigContext } from '@bingads-webui-campaign-react/smart-page-context';
import {
  getComponentById,
} from '@bingads-webui-campaign-react/smart-component-util';

import { SmartSocialLinksView } from './smart-social-links-view';
import { getDataProperties } from './data-config';

export const SmartSocialLinksConnector = ({ id, isEditMode }) => {
  const { siteConfig } = useContext(SiteConfigContext);
  const i18n = useContext(I18nContext);
  const componentConfigs = getComponentById(siteConfig, id);
  const socialLinksConfigs = {};
  const dataProperties = getDataProperties(i18n);
  let showSocialLinks = false;

  Object.entries(dataProperties).forEach(([, socialLinkMapping]) => {
    socialLinksConfigs[socialLinkMapping.key] = componentConfigs[socialLinkMapping.key] ?
      componentConfigs[socialLinkMapping.key] : {};

    if (socialLinksConfigs[socialLinkMapping.key].isDisplay) {
      showSocialLinks = true;
    }
  });


  return useMemo(() => (
    showSocialLinks
      ? <SmartSocialLinksView
        i18n={i18n}
        id={id}
        socialLinksConfigs={socialLinksConfigs}
        isEditMode={isEditMode}
      />
      : null
  ), [i18n, id, isEditMode, showSocialLinks, socialLinksConfigs]);
};

SmartSocialLinksConnector.propTypes = {
  id: PropTypes.string.isRequired,
  isEditMode: PropTypes.bool,
};

SmartSocialLinksConnector.defaultProps = {
  isEditMode: false,
};
